import { PlatformProfileResult } from '@mews-commander/data-access';
import { Avatar, Body, Link, Stack } from '@optimus-web/core';
import { useDialog } from '@mews/framework';
import { useAvatarSrc } from '@mews-commander/utils';
import { PlatformProfileDetails } from '../PlatformProfileDetail';

interface PlatformProfileTableAvatarProps {
    platformProfile: PlatformProfileResult;
}

export const PlatformProfileTableAvatar = ({ platformProfile }: PlatformProfileTableAvatarProps) => {
    const avatarImage = useAvatarSrc(platformProfile.imageId);
    const [{ active, onClose }, openDialog] = useDialog();
    return (
        <>
            {' '}
            <Stack spacing="100" itemAlignment="center">
                <Avatar src={avatarImage} title={platformProfile.fullName || ''} size="small" />

                <Body size="small" ellipsis maxLines={1}>
                    <Link variant="basic" onClick={() => openDialog()}>
                        {platformProfile.fullName}
                    </Link>
                </Body>
            </Stack>
            {platformProfile.profileId && active && (
                <PlatformProfileDetails platformProfileId={platformProfile.profileId} closeDetails={onClose} />
            )}
        </>
    );
};
